module.exports = __webpack_public_path__ + "resources/images/huistaken-db2dd9f4ee8cb0d7e86157afe358c6ef-cache.jpg";